import React from 'react';
import {Link} from "react-router-dom";
import '../../img/wrapper/contact.jpg';
import '../../img/wrapper/about.jpg';
import '../../img/wrapper/decorative.jpg';
import '../../img/wrapper/classic.jpg';
import '../../img/wrapper/pots.jpg';
import '../../img/wrapper/basket.jpg';

export default class Aside extends React.Component{
	constructor(props){
		super(props);
		this.state={};
		this.changeWrapper=this.changeWrapper.bind(this);
	}
	changeWrapper(e){
		const a = document.getElementById('root');
		const b = e.target.dataset.img||e.target.firstElementChild.dataset.img;
		a.style.backgroundImage=`url('img/${b}.jpg')`;
	}
	render(){
		return(
			<aside>
				<div className='aside-wrap'>
					<div className={this.props.burgOpen?'active':null}
						onClick={this.props.changeBurg}
						id='burg'>
						<div className='top arrow'></div>
						<div className='down arrow'></div>
					</div>
					<div className='logo'>housing</div>
					<div className='basket'>
						<Link onClick={(e) =>{this.changeWrapper(e)}} to='/purchase'>
							<img data-img='basket' src={require('../../img/basket.png')}/>
						</Link>
					</div>
				</div>
				<nav className={this.props.burgOpen?'active':null}>
					<ul onClick={(e) =>{this.props.changeBurg();this.changeWrapper(e)}}>
						<li><Link data-img='pots' to='/pots'>кашпо</Link></li>
						<li><Link data-img='classic' to='/classic'>класичнi горщики</Link></li>
						<li><Link data-img='decorative' to='/decorative'>декоративнi горщики</Link></li>
						<li><Link data-img='about' to='/about'>трiшечки про нас</Link></li>
						<li><Link data-img='contact' to='/contact'>нашi контакти</Link></li>
					</ul>
				</nav>
			</aside>
		)
	}
}